export default function PageTransitionLoader({size}) {
    return (
        <img src="/assets/infinity-loader.svg" className={`w-${size} pointer-events-none`} alt=""/>
    )
}